import type { Role } from 'src/types/user';
import type {
  ModuleRole,
  ModuleRoleUpstream,
  UserDetail,
  UserDetailUpstream,
} from 'src/types/userModule';
import { mapRoleToProps } from 'src/components/app/context/UserContext/helper';

/**
 * Checks if current user access to some modules (= tools) will be removed by role changes
 */
export const confirmationNeeded = (
  userModules: ModuleRole[],
  currentUserModulesPerRole: number[],
) => {
  if (!currentUserModulesPerRole) return false;
  const userModuleIds = userModules
    ? userModules.reduce(
        (acc: number[], userModule) =>
          userModule.module.is_active ? [...acc, userModule.module.id] : acc,
        [],
      )
    : [];
  return (
    !!userModules &&
    currentUserModulesPerRole.some(
      (currentUserModulePerRole) =>
        !userModuleIds.includes(currentUserModulePerRole),
    )
  );
};

export const reduceRoles = (moduleRoles: ModuleRole[]) =>
  moduleRoles.reduce(
    (acc: Role[], { role }) =>
      acc.find(({ id }) => id == role.id) ? acc : [...acc, role],
    [],
  );

export const mapModuleRoleToProps = (data: ModuleRoleUpstream): ModuleRole => ({
  id: data.id,
  role: mapRoleToProps(data.role),
  module: data.module,
});

export const mapModuleRolesToProps = (data: ModuleRoleUpstream[]) =>
  Array.isArray(data) ? data.map(mapModuleRoleToProps) : [];

export const mapUserDetailToProps = (data: UserDetailUpstream): UserDetail => ({
  business_unit_id: data.business_unit_id,
  email: data.email,
  role: data.role ? mapRoleToProps(data.role) : null,
  first_name: data.first_name,
  id: data.id,
  is_user_active_in_survey: data.is_user_active_in_survey,
  last_name: data.last_name,
  permissions: data.permissions,
});

export const initialUserData: UserDetail = {
  business_unit_id: null,
  email: '',
  role: null,
  first_name: '',
  id: 0,
  is_user_active_in_survey: null,
  last_name: '',
  permissions: [],
};
